// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__31iDN","bigColWidth":"Table_bigColWidth__1rkPy","biggerColWidth":"Table_biggerColWidth__2Y_4R","row":"Table_row__5vwX7","col":"Table_col__1RbWJ"};